import { render } from "./FactsPage.vue?vue&type=template&id=46ff120a&scoped=true"
import script from "./FactsPage.vue?vue&type=script&lang=js"
export * from "./FactsPage.vue?vue&type=script&lang=js"

import "./FactsPage.vue?vue&type=style&index=0&id=46ff120a&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ff120a"]])

export default __exports__